export default "__VITE_ASSET__DTfLspVq__"